import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

export const APPLICANTS_LIST_KEY = 'applicants-list'

export type Applicant = {
  id: string
  email: string
  name?: string
  invitedAt: string
  hasLoggedIn: boolean
  lastLogin: string | null
}

type ApplicantsRequest = {
  cursor: number
  limit: number
}

type ApplicantsResponse = {
  applicants: Applicant[]
  total: number
}

export function useApplicants(params: ApplicantsRequest) {
  return useQuery({
    queryKey: [APPLICANTS_LIST_KEY, params],
    queryFn: async () =>
      (await apiClient.get<ApplicantsResponse>('/int/v3/users/applicants', { params })).data,
    refetchOnWindowFocus: false,
    retry: false,
  })
}
